// extracted by mini-css-extract-plugin
export default {"center":"style_center__V2P8C"};